var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodAdd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.619,
    height: 16.619,
    viewBox: "0 0 16.619 16.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add",
    d: "M23.619,15.31a1.662,1.662,0,0,1-1.662,1.662H16.971v4.986a1.662,1.662,0,1,1-3.324,0V16.971H8.662a1.662,1.662,0,1,1,0-3.324h4.986V8.662a1.662,1.662,0,1,1,3.324,0v4.986h4.986A1.662,1.662,0,0,1,23.619,15.31Z",
    transform: "translate(-7 -7)",
    fill: "#716c6c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdAdd);
export default __webpack_public_path__ + "static/media/prodAdd.20f54d8495c3b99dda5212ee7944b580.svg";
export { ForwardRef as ReactComponent };